import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './pages/Header';
import Home from './pages/Home';
import Footer from './pages/Footer';

function App() {
  return (
    <>
      <Header />
      <Home />
      <Footer/>
    </>
  );
}

export default App;
